import { filterBy, orderBy } from '@progress/kendo-data-query';
import { Button } from '@progress/kendo-react-buttons';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid';
import { Label } from '@progress/kendo-react-labels';
import Body from 'commons/card/Body';
import CollapsableCard from 'commons/card/CollapsableCard';
import LoadingCardBody from 'commons/card/LoadingCardBody';
import { FormDatePicker, FormRadioGroup } from 'commons/forms/form';
import { required, requiredDateLower } from 'commons/forms/validators';
import * as dates from 'commons/models/dates';
import Blockquote from 'commons/status/Blockquote';
import { Numerique } from 'pages/gant/constantes/medias';
import PropTypes from 'prop-types';
import React, {
  Fragment,
  useCallback,
  useEffect, useMemo, useState
} from 'react';
import { useDropzone } from 'react-dropzone';
import { useSearchParams } from 'react-router-dom';
import 'scss/_hotFolder.scss';
import 'scss/_tablePage.scss';
import { useAddDocumentMutation, useAddDocumentsMetaMutation, useAddTacheMutation, useGetObjectifQuery } from '../../redux/api/cache';
import { useAppSelector } from '../../redux/store';

export default function HotFolder(props) {
  const [files, setFiles] = useState([]);
  const [isLoaded, setIsLoaded] = useState(true);
  const [showBlockQuoteCampNum, setShowBlockQuoteCampNum] = useState(false);
  const [showBlockQuoteFileEmpty, setShowBlockQuoteFileEmpty] = useState(false);
  const [showBlockQuoteNumerique, setShowBlockQuoteNumerique] = useState(false);

  let [searchParams] = useSearchParams();
  const [objectif, setObj] = useState({
    doc_role: ""
  });
  const user = useAppSelector(state => state.appState.user);
  const [addDocumentsMeta] = useAddDocumentsMetaMutation();
  const [addDocuments] = useAddDocumentMutation();
  const [addTache] = useAddTacheMutation();

  const { data: listObjectif } = useGetObjectifQuery();

  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          file.bin = reader.result.split(',')[1] ?? "";
          file.Nom = (file.name == undefined || file.name == "" || file.name == null) ? file.path.split('.') : file.name;
          file.Chemin = file.path;
          file.Taille = file.size;
          file.saved = false;
          delete file.name;
        };
        reader.readAsDataURL(file);

        let newFiles = [...files];
        setFiles(newFiles.concat(acceptedFiles));
      });
    },
    [files]
  );

  useEffect(() => {
    setFiles(files);
    let showErrorCampNum = !files.every(file => {
      const valeurCampNum = props.camp_num ? props.camp_num : "\\d{4}";
      const regex = new RegExp("Pub_(C|A)" + valeurCampNum + "_[^%]*$");
      return regex.test(file.name);
    });
    let showErrorNumerique = props.params.media_cd && props.params.media_cd === Numerique ? !files.every(file => {
      const valeurCampNum = props.camp_num ? props.camp_num : "\\d{4}";
      const regex = new RegExp(".*_\\D{2}_\\D{2}_.*_.*_(C|A)" + valeurCampNum + "_Numerique");
      return regex.test(file.name);
    }) : false;
    setShowBlockQuoteCampNum(props.params.media_cd && props.params.media_cd === Numerique ? false : showErrorCampNum);
    setShowBlockQuoteNumerique(showErrorCampNum && showErrorNumerique);
    let showErrorFileEmpty = !files.every(file => file.size !== 0);
    setShowBlockQuoteFileEmpty(showErrorFileEmpty);
  }, [files, props.camp_num]);

  const { getRootProps, getInputProps, isDragActive, fileRejections } = useDropzone({ onDrop, accept: { 'image/*': [], 'video/*': [], 'audio/*': [], "application/pdf": ['.pdf'], "application/zip": ['.zip'] }, });

  const GridRenderer = () => {
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(10);
    const [sort, setSort] = useState([]);
    const [filters] = useState([]);

    const removeFile = async (selectedRow) => {
      let selectedFile = files.find((file) => file.Nom === selectedRow.Nom);
      if (selectedFile.saved) {
        props.toggleDialog();
      } else {
        let newFiles = [...files];
        newFiles.splice(
          files.findIndex((file) => file.Nom === selectedRow.Nom),
          1
        );
        setFiles(newFiles);
      }
    };
    const customButtonsCells = (rowProps) => <td style={{ textAlign: "right" }}>
      <span className="blueButton k-icon k-font-icon k-i-trash" style={{ marginLeft: "15px", marginRight: "15px", cursor: "pointer" }} onClick={() => { removeFile(rowProps.dataItem); }} />
    </td>;
    return (
      <div>
        <Grid
          selectedField="selected"
          style={{ height: '100%' }}
          data={filterBy(orderBy(files, sort).slice(skip, take + skip), {
            logic: 'or',
            filters: filters,
          })}
          skip={skip}
          take={take}
          total={files.length}
          pageable={true}
          onPageChange={(event) => {
            setSkip(event.page.skip);
            setTake(event.page.take);
          }}
          sortable
          sort={sort}
          onSortChange={(e) => setSort(e.sort)}
        >
          <GridColumn title={'Nom'} field={'name'} />
          <GridColumn title={'Chemin'} field={'path'} />
          <GridColumn title={'Taille'} field={'size'} />
          <GridColumn title={'Actions'} cell={customButtonsCells} />
          <GridNoRecords>
            <p>Aucun document</p>
          </GridNoRecords>
        </Grid>
      </div>
    );
  };

  const send = async (dataItem) => {
    if (showBlockQuoteCampNum || showBlockQuoteFileEmpty || showBlockQuoteNumerique)
      return;

    const dateLimite = dataItem.dateLimite ? dates.dateBdFormat(dataItem.dateLimite) : '';

    setIsLoaded(false);
    let allFiles =
      props.params !== undefined
        ? files.map((file) => ({ ...file, ...props.params }))
        : files.map((file) => ({ ...file, from: 'publicite' }));

    if (props.numeric) {
      allFiles.map(elem => elem.doc_role = objectif.doc_role === "Aucun" ? "" : objectif.doc_role);
    }

    let result = await addDocuments({ update: 'non', body: allFiles }).unwrap();
    result.image.forEach(async (res) => {
      if (res.success) {
        files.splice(
          files.findIndex((file) => file.nom === res.nom),
          1
        );
        if (props.params !== undefined) {
          await addDocumentsMeta([{
            rid_doc: res.ridDoc,
            docm_descr: 'DocDtLimite',
            docm_val: dateLimite,
            docm_visible: false
          }, {
            rid_doc: res.ridDoc,
            docm_descr: 'appr_req',
            docm_val: dataItem.approbation,
            docm_visible: false
          }, {
            rid_doc: res.ridDoc,
            docm_descr: 'usr_cd',
            docm_val: user,
            docm_visible: false
          },
          {
            rid_doc: res.ridDoc,
            docm_descr: 'statut',
            docm_val: "non approuvé",
            docm_visible: false
          }]);
          if (dataItem.approbation) {
            await addTache({
              rid: null,
              tac_id: null,
              tac_key: null,
              tac_statut: null,
              tac_date: dates.dateBdFormat(new Date()),
              tac_time: dates.timeBdFormat(new Date()),
              tac_descr: '',
              tac_texte: 'Approabtion d\'un document',
              tac_type: 'DocumentsPub',
              module: 'pub',
              div_num: -1,
              camp_seq: props.params.camp_seq,
              media_cd: props.params.media_cd,
              diff_cd: props.params.diff_cd,
              mf_format: props.params.mf_format ? props.params.mf_format : "",
              campr_date: props.params.campr_date,
              ridDoc: res.ridDoc,
              extraKey: searchParams.get('campagne'),
              DocDtLimite: dateLimite,
              usr_cd_crea: user
            });
          }
        }
      }
    });
    if (props.onSave !== undefined) {
      props.onSave();
    }
    setIsLoaded(true);
  };

  const handleChange = (event) => {
    setObj({
      doc_role: event.target.value,
    });
  };

  const dateLimiteValidators = useMemo(() => [(e) => required(e, `Date`), (e) => requiredDateLower(e, dates.dateBdToDate(props.params.campr_date, '00:00'), "La date limite", "la date de début de la campagne")], []);

  return (
    <Fragment>
      <CollapsableCard type="none" canCollapse={false}>
        <Body>
          <Blockquote icon="information" type="info">
            <ul style={{ paddingLeft: '1.5rem' }}>
              <li>
                <p>
                  {`Pour obtenir plus d'informations sur la nomenclature des
                  fichiers, consultez  `}
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`http://10.20.2.34/DocPublicite/Nomenclature Documents PUB.pdf`}
                  >
                    la documentation.
                  </a>
                </p>
              </li>
              <li>
                <p>Maximum de 200MB.</p>
              </li>
            </ul>
          </Blockquote>
          {showBlockQuoteCampNum && <Blockquote icon="error" type="error">
            <p>Le nom du document ne respecte pas la nomenclature des documents!</p>
          </Blockquote>}
          {showBlockQuoteNumerique && <Blockquote icon="error" type="error">
            <p>Le nom du document ne respecte pas la nomenclature des documents numériques!</p>
          </Blockquote>}
          {showBlockQuoteFileEmpty && <Blockquote icon="error" type="error">
            <p>Le fichier ne peut pas être vide!</p>
          </Blockquote>}
          {fileRejections.length > 0 && <Blockquote icon="error" type="error">
            <p>{`Erreur lors de l'ajout du fichier! Le type de fichier n'est pas supporté.`}</p>
          </Blockquote>}
          {!isLoaded && <LoadingCardBody />}
          <section {...getRootProps()} className="container-drag">
            <div tabIndex={0} className="dropzone">
              <input {...getInputProps()} accept='.pdf' />
              <i className="fas fa-inbox icon-dnd" />
              {isDragActive ? (
                <p>Déposer le fichier ici ...</p>
              ) : (
                <><p>Glisser-déposer</p>
                  <em>Seulement les formats images, vidéos ou pdf sont supportés</em></>
              )}
            </div>
            <aside>
              <ul />
            </aside>
          </section>
          {GridRenderer()}
          {props.numeric && (<div style={{ marginTop: '15px' }}>
            <Label
              style={{
                fontWeight: 'bold',
                color: '#a5a5a5'
              }}>
              Objectif
            </Label>
            <br />
            <DropDownList
              style={{
                width: "300px",
              }}
              data={listObjectif?.data?.map((item) => item.objectif)}
              defaultItem="Aucun"
              value={objectif.doc_role}
              onChange={handleChange}
            />
          </div>)}
          <div>
            <Form
              ignoreModified={true}
              onSubmit={send}
              render={(formRenderProps) => (
                <FormElement>
                  <fieldset className={'k-form-fieldset'}>
                    <div className="row k-d-flex k-justify-content-end" style={{ marginTop: '2rem', marginBottom: '2rem' }}>
                      {props.showForm && (<><div className="col-md-3 ">
                        <Field
                          id={'Approbation'}
                          name={'approbation'}
                          label={'Approbation requise'}
                          component={FormRadioGroup}
                          data={[
                            { label: 'Oui', value: true },
                            { label: 'Non', value: false },
                          ]}
                        />
                      </div>
                        {formRenderProps.valueGetter("approbation") && (<div className="col-md-3 ">
                          <Field
                            id={'DateLimite'}
                            name={'dateLimite'}
                            label={'Date limite'}
                            component={FormDatePicker}
                            validator={dateLimiteValidators}
                            wrapperStyle={{
                              minWidth: '10rem',
                            }} />
                        </div>)}</>)}
                    </div>

                    <div style={{ marginTop: '1rem' }} className="k-form-buttons">
                      <Button
                        type={'submit'}
                        disabled={files.length <= 0}
                        className="blueButton">
                        Enregistrer
                      </Button>
                      {files.length > 0 && (
                        <Button
                          onClick={() => {
                            setFiles([]);
                          }}
                          className="whiteButton"
                          style={{ width: '100px' }}>
                          Réinitialiser
                        </Button>
                      )}
                    </div>
                  </fieldset>
                </FormElement>
              )}
            />
          </div>
        </Body>
      </CollapsableCard>
    </Fragment>
  );
}

HotFolder.propTypes = {
  onSave: PropTypes.func,
  params: PropTypes.any,
  toggleDialog: PropTypes.func,
  numeric: PropTypes.bool,
  camp_num: PropTypes.number,
  showForm: PropTypes.bool
};
